export default {"src":"/_next/static/media/externallink.2fb79dd1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};